import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { APIS, MESSAGES, USER_DETAILS } from 'app/common/constants';
import { HttpService } from 'app/core/services/http.service';
import { UserService } from 'app/core/services/user.service';
import { environment } from '../../../../environments/environment';
import { Result } from 'app/models/result';
import { ActivatedRoute, NavigationEnd, Params, Router} from "@angular/router";
import { FilterForm, Filters} from "./client-inspection.model";
import { filter, takeUntil, catchError, debounceTime, distinctUntilChanged, map, switchMap} from "rxjs/operators";
import { Subject, Observable, of } from "rxjs";
import { ClientDecision } from 'app/models/decision';
import { MultiSelectComponent } from 'ng-multiselect-dropdown';


const clientInspection = JSON.parse(environment.clientInspection);
const showPendingDecision = JSON.parse(environment.showPendingDecision);

@Component({
  selector: 'app-client-inspection',
  templateUrl: './client-inspection.component.html',
  styleUrls: ['./client-inspection.component.css'],
})
export class ClientInspectionComponent implements OnInit, OnDestroy, AfterViewInit {
  title = 'Inspection';
  divisionList: any = [];
  departmentList: any = [];
  updatedDepartmentList: any = [];
  url = APIS.INSPECTION_LIST;
  texts = MESSAGES;
  updateUrl = APIS.UPDATE_QC_DATA;
  consoleCenters: any = [];
  result: Result[];
  clientDecisions: ClientDecision[];
  PendingDecisions: Number = 0;
  selectedConsoleCenter = ''; // localStorage.getItem(USER_DETAILS.LOCATION);
  selectedDivision = '';
  selectedDepartment = '';
  selectedDepartments:any[] = [];
  dropdownSettings:any = {};
  supplierSuggestions: string[] = [];
  supplierNameInput = new Subject<string>();
  selectedSupplierId: number | null = null;
  selectedResult: string = null;
  selectedClientDecision: number = null;
  styleCodesList: any[] = [];
  isLoadingStyleCodes: boolean = false;
  styleCodeSearchInput = new Subject<string>();
  startDate = new Date(
    new Date().setDate(new Date().getDate() - clientInspection['date-range-minus'])
  ).toISOString().split('T')[0];
  endDate = new Date().toISOString().split('T')[0];
  headerObj = clientInspection['table'];
  roleId = parseInt(localStorage.getItem(USER_DETAILS.ROLE));
  isClient: boolean = (this.roleId === 1 ||this.roleId === 7) ? false : true;
  baseUrl = APIS.INSPECTION_LIST;
  po_qty = 0;
  role = 'client';
  filterForm: FormGroup;
  subscription;
  total_qty = 0;
  showConsolCenter: string = clientInspection['consol-filter'];
  resultFilter: string = clientInspection['result-filter'];
  clientDecisionFilter: string = clientInspection['show-client-decision-filter'];
  showDepartment: string = clientInspection['department-list'];
  departmentMultiselect: string = clientInspection['department-multiselect'];
  showDivision: string = clientInspection['division-filter'];
  showColour: string = clientInspection['colour-filter'];
  showPoNumber: string = clientInspection['po-number'];
  showPendingDecisions: boolean = showPendingDecision;
  @ViewChild('dropdownContainer', { static: false }) dropdownContainer: MultiSelectComponent;

  destroy$ = new Subject();

  constructor(private httpService: HttpService,
              private userService: UserService,
              private router:Router,
              private route:ActivatedRoute,
              private fb: FormBuilder) {
    this.subscription = this.userService.recordsUpdate.subscribe(res => {
      this.po_qty = 0;
      this.total_qty = 0;
      res.forEach(item => {
        this.po_qty = this.po_qty + item['order_quantity'];
        this.total_qty = this.total_qty +item['inspection_quantity'];
      });
    });
  }

  initForm() {
    this.filterForm = this.fb.group({
      style_code: [''],
      colour: [''],
      supplier_name: [''],
      client_pos: [''],
    });
  }

  defaultFilter() {
    return { filterKey: 'exists_inspection_report', filterValue: '1' };
  }

  genFilters() {
    const filters = Object.keys(this.filterForm.value);
    const results = filters.map((obj) => {
      return { filterKey: obj, filterValue: this.filterForm.value[obj]?.trim() };
    }).filter((ele) => { return ele.filterValue });
    results.push(this.defaultFilter());
    return results;
  }

  ngOnInit(): void {
    this.setDropdownSettings();

    this.initForm();
    if(!!this.showDepartment){
      this.httpService.getDataWithCache(APIS.GET_DEPARTMENT_LIST).subscribe(res => {
        this.divisionList = [...new Set(res.data.map(item => item.division))]
        this.departmentList = res.data;
        this.updatedDepartmentList = this.departmentList
      })
    }
    if (!!this.showConsolCenter) {
      this.httpService.getDataWithCache(APIS.CONSOLE_CENTERS).subscribe(res => {
        console.log(res.data,"consol");

        this.consoleCenters = res.data;
      });
    }
    if (!!this.resultFilter) {
      this.httpService.getDataWithCache(APIS.GET_RESULT_LIST).subscribe(res => {
        const response = res.data.map((item: string) => { return { id: item, result: item }; });
        response.splice(3);
        this.result = [
          { id: '', result: '' },
        ].concat(response);
      });
    }
    if (!!this.clientDecisionFilter) {
      this.httpService.getDataWithCache(APIS.CLIENT_DECISIONS).subscribe(res => {
        this.clientDecisions = [{ id: null, client_decision_description: 'No decision' }].concat(res.data);
      })
    }
    this.supplierNameInput
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(term => this.searchSuppliers(term))
      )
      .subscribe(suggestions => this.supplierSuggestions = suggestions);

    this.setDataFromParams();
    // this.userService.valueChange.next({ url: this.url, data: data });
    this.subscribeForRouteChange();

    this.styleCodeSearchInput.pipe(debounceTime(300),distinctUntilChanged(),).subscribe((value: string) => {
      if (value) {
        this.getStyleCodeList(value);
      }
    });
  }

  receivePendingDecisions(args: number) {
    this.PendingDecisions = args;
  }

  
  getStyleCodeList(value: string) {
    if (!value || value.trim() === '') {
      this.styleCodesList = [];
      return;
    }
    
    this.isLoadingStyleCodes = true;
    this.httpService.getData(APIS.GET_SIZE__CHART_LIST, { styleCode: value }).subscribe(
      (res) => {
        this.styleCodesList = res?.data || [];
        this.isLoadingStyleCodes = false;
      },
      (err) => {
        this.styleCodesList = [];
        this.isLoadingStyleCodes = false;
      }
    );
  }

  onStyleCodeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.styleCodeSearchInput.next(input.value);
  }

  onStyleCodeSelect(suggestion: any): void {
    this.filterForm.patchValue({ style_code: suggestion.style_code });
    this.styleCodesList = [];
  }
  
  searchSuppliers(term: string): Observable<string[]> {
    if (term === '') {
      return of([]);
    }
    return this.httpService.getDataWithCache(APIS.SUPPLIER_LIST)
      .pipe(
        map(response => {
          const suppliers = response.data.map((item: { id: number, supplier_name: string }) => item);
          const uniqueSuppliers = new Set();
          return suppliers.filter(supplier => {
            const normalizedSupplierName = supplier.supplier_name.trim().toLowerCase();
            const isDuplicate = uniqueSuppliers.has(normalizedSupplierName);
            uniqueSuppliers.add(normalizedSupplierName);
            return !isDuplicate && normalizedSupplierName.includes(term.toLowerCase());
          });
        }),
        catchError(() => of([]))
      );
  }

  onSupplierNameInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.supplierNameInput.next(input.value);
  }

  onSuggestionSelect(suggestion: { id: number, supplier_name: string }): void {
    this.filterForm.patchValue({ supplier_name: suggestion.supplier_name });
    this.selectedSupplierId = suggestion.id;
    this.supplierSuggestions = [];
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest('.suggestions-list') === null && target.closest('input[formControlName="supplier_name"]') === null) {
      this.supplierSuggestions = [];
    }
    if (target.closest('.suggestions-list') === null && target.closest('input[formControlName="style_code"]') === null) {
      this.styleCodesList = [];
    }
  }

  setDropdownSettings(){
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'department',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll:false,
      customApplyButton: true,
      badgeRemoveIcon: '',
      noFilteredDataAvailablePlaceholderText : 'No Record Found',
      noDataAvailablePlaceholderText : 'No Record Found'
    };
  }

  subscribeForRouteChange(){
    this.router.events
      .pipe(filter(event=> event instanceof NavigationEnd),
        takeUntil(this.destroy$))
      .subscribe((event:NavigationEnd)=>{
        this.setDataFromParams();
    })
  }

  setDataFromParams(){
    // const data ={...this.setData()};
    const data = {};
    const queryPrams:Params = this.route.snapshot.queryParams;
    if(queryPrams['filters']){
      data['filters'] = queryPrams['filters'];
    }else{
      data['filters'] = JSON.stringify(this.genFilters());
    }

    this.setFiltersFromParams(
      queryPrams['filters']?
      JSON.parse(queryPrams['filters']) : null
    );
    this.startDate = data['startDate'] = queryPrams['startDate'] ?? this.startDate;
    this.endDate = data['endDate'] = queryPrams['endDate'] ?? this.endDate;
    if(queryPrams['consolCentre']){
      this.selectedConsoleCenter = data['consolCentre'] = queryPrams['consolCentre'];
    }else{
      this.selectedConsoleCenter = '';
      delete data['consolCentre'];

    }
    if(queryPrams['result']){
      data['result'] = queryPrams['result'];
      this.selectedResult = data['result'];
    } else {
      delete data['result'];
      this.selectedResult = '';
    }

    if(queryPrams['clientDecision']){
      data['clientDecision'] = queryPrams['clientDecision'];
      this.selectedClientDecision = data['clientDecision'];
    } else {
      delete data['clientDecision'];
      this.selectedClientDecision = null;
    }

    if (queryPrams['division']) {
      this.selectedDivision = data['division']  = queryPrams['division'];
    }else{
      this.selectedDivision ='';
    }
    if (queryPrams['department']) {
      const deptList =  queryPrams['department'];
      data['department'] = deptList;
      this.selectedDepartments = deptList.split(',').map(id => {
        const deptObj = this.departmentList.find(dept => dept.id === id.trim());
        return deptObj ? deptObj : null;
      }).filter(item => item);
    }
    this.userService.valueChange.next({ url: this.url, data: data });
  }

  setFiltersFromParams(filters){
    this.filterForm.reset();
    if(!filters) return;
    const fetchedValues:FilterForm = {};

    filters.forEach((filter: {filterKey:string,filterValue:string}) => {
      switch (filter.filterKey) {
        case Filters.EXIST_INSP_REPORT:
          break;

        case Filters.STYLE_CODE:
          fetchedValues[Filters.STYLE_CODE] = filter.filterValue;
          break;

        case Filters.COLOR:
          fetchedValues[Filters.COLOR] = filter.filterValue;
          break;

        case Filters.SUPPLIER_NAME:
          fetchedValues[Filters.SUPPLIER_NAME] = filter.filterValue;
          break;

        case Filters.CLIENT_PO:
          fetchedValues[Filters.CLIENT_PO] = filter.filterValue;
          break;

        default:
          break;
      }

    });
    this.filterForm.patchValue(fetchedValues);
  }

  setQueryParams(data= null){
    const queryPrams:Params ={};
    // if(data['startDate']){
    //   queryPrams['startDate'] = data['startDate'];
    // }

    if(this.startDate){
      queryPrams['startDate'] = this.startDate;
    }
    if(this.endDate){
      queryPrams['endDate']=this.endDate;
    }
    if(this.selectedConsoleCenter){
      queryPrams['consolCentre'] = this.selectedConsoleCenter
    }
    const filters = this.genFilters();
    if(filters && Object.keys(filters).length){
      queryPrams['filters']= JSON.stringify(filters);
    }
    if(this.selectedResult){
      queryPrams['result']= this.selectedResult;
    }

    queryPrams['clientDecision']= this.selectedClientDecision;

    if (this.selectedDivision) {
      queryPrams['division'] = this.selectedDivision;
    }
    if (this.selectedDepartments.length>0) {
      queryPrams['department'] = this.selectedDepartments.map(dept => dept.id).join(',')
    }

    this.router.navigate([],{
      relativeTo:this.route,
      queryParams:queryPrams,
      // queryParamsHandling:'merge'
    });
    // this.userService.valueChange.next({ url: this.url, data: data });
  }

  dateSelected() {
    this.setQueryParams()
    // this.userService.valueChange.next({ url: this.url, data: data });
  }

  selectConsoleCenter(event) {
    this.selectedConsoleCenter = event.target.value;
    this.setQueryParams();
    // this.userService.valueChange.next({ url: this.url, data: data })
  }

  selectDivision(event) {
    this.selectedDivision = event.target.value;
    if (this.selectedDivision) {
      this.updatedDepartmentList = this.departmentList
        .filter(item => item.division === this.selectedDivision);
      } else {
      this.updatedDepartmentList = this.departmentList
    }
    this.selectedDepartments=[];
    this.selectedDepartment = '';
    this.setQueryParams();
  }

  sortDepartments() {
    this.selectedDepartments.sort((a, b) => a.id.localeCompare(b.id))
    const selectedIds = this.selectedDepartments.map(ele=>ele.id);

    this.updatedDepartmentList.sort((a, b) => {
      const isSelectedA = selectedIds.includes(a.id);
      const isSelectedB = selectedIds.includes(b.id);

      if (isSelectedA && !isSelectedB) return -1;
      if (!isSelectedA && isSelectedB) return 1;
      return a.id.localeCompare(b.id);
    });
    this.updatedDepartmentList = [...this.updatedDepartmentList];

  }

  ngAfterViewInit() {
    setTimeout(() => this.injectApplyButton(), 100);
  }

  closeDropdown() {
    if (this.dropdownContainer) {
      this.dropdownContainer.closeDropdown();
    }
  }

  injectApplyButton() {
    const dropdown = document.querySelector('.multiselect-dropdown .dropdown-list');
    if (dropdown && !document.getElementById('apply-btn')) {
      const applyButton = document.createElement('button');
      applyButton.id = 'apply-btn';
      applyButton.innerText = 'Apply';
      applyButton.className = 'btn btn-primary dd-apply-button btn-sm';
      applyButton.onclick = () => this.selectDepartment();
      dropdown.appendChild(applyButton);
    }
  }

  selectDepartment() {
    this.closeDropdown();
    this.setQueryParams();
  }

  selectResult(event: Event) {
    const selectedInput = event.target as HTMLInputElement;
    if (selectedInput?.value) {
      this.selectedResult = selectedInput.value;
    }
    this.setQueryParams();
  }
  selectClientDecision(event: Event) {
    const selectedInput = event.target as HTMLSelectElement;
    if(selectedInput.value === "null"){
      this.selectedClientDecision=null;
    }
    else{
      this.selectedClientDecision = Number(selectedInput.value);
    }
    this.setQueryParams();
  }

  applyFilter() {
    this.setQueryParams()
    // this.userService.valueChange.next({ url: this.url, data: data });
  }

  addResultFilter(data) {
    if (this.resultFilter) {
      data['result'] = this.selectedResult;
    } else {
      delete data?.result

    }
  }

  clearDropDownFilters() {
    if (this.resultFilter) {
      this.selectedResult = null;
    }
    if (this.selectedDivision) {
      this.selectedDivision = "";
    }
    if (this.selectedDepartment) {
      this.selectedDepartment = "";
    }
  }


  clearFilter() {
    this.clearDropDownFilters();
    this.filterForm.reset();
    this.setQueryParams();
  }

  selectFilter(event) {
    console.log(event);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
